import { AfterViewInit, Component, ViewChild } from '@angular/core';
import { TableMobileComponent } from '@beego/ngx-table';
import { DeviceTypesController } from '../device-types.controller';

@Component({
	selector: 'device-types-mobile-component',
	templateUrl: 'device-types.mobile.component.html',
	styleUrls: ['./device-types.mobile.component.scss'],
})
export class DeviceTypesMobileComponent implements AfterViewInit {
	@ViewChild(TableMobileComponent) private readonly tableComponent: TableMobileComponent;

	constructor(public readonly controller: DeviceTypesController) {}

	public ngAfterViewInit(): void {
		this.controller.tableComponent = this.tableComponent;
	}
}
